<template>
  <div id="resumo-proposta">
    <modal-form v-model="ajuda" @close="ajuda = false" hide-footer>
        <template v-slot:title>
          Saldo utilizado do FGTS
        </template>
        <template v-slot:body>
          <div>
            O Saldo utilizado do FGTS indica o valor que será bloqueado na conta de FGTS e também representa a soma das
            parcelas antecipadas do Saque-Aniversário.
          </div>
          <strong>Importante:</strong> este valor diminui a cada ano, a partir do desconto automático de cada parcela no
          vencimento indicado.
          <v-btn class="mt-5" large block color="info" @click="ajuda = false">Entendi</v-btn>
        </template>
      </modal-form>
    <v-row>
      <v-col cols="12" class="py-0 grey--text text--darken-3 font-weight-medium">
        <resumo-cliente-dados-gerais :model="model"></resumo-cliente-dados-gerais>
        <br/>
        <v-row justify="center">
          <v-col cols="12" sm="8" md="6" class="ma-0">
            <v-row>
              <v-col cols="12" class="text-subtitle-1">Detalhes da Operação</v-col>
              <v-col cols="12" class="pl-0">
                <div class="row-item destaque">
                  Valor Solicitado
                  <v-icon @click="openAjuda" small color="primary" class="ml-1 mt-n1">ph-question</v-icon>
                  <span class="item-value">R$ {{ model.VlrSolicitado }}</span>
                </div>
                <div class="row-item">
                  Valor IOF
                  <span class="item-value"> R$ {{ $api.UI.Format.Decimal(model.VlrIOF) }} </span>
                </div>
                <div class="row-item">
                  Valor Tarifa de Serviços
                  <span class="item-value"> R$ {{ $api.UI.Format.Decimal(model.VlrOutrasDespesas) }} </span>
                </div>
                <div class="row-item">
                  Valor TAC
                  <span class="item-value"> R$ {{ $api.UI.Format.Decimal(model.VlrTAC) }} </span>
                </div>
                <div class="row-item">
                  Taxa de Juros
                  <span class="item-value">
                    {{ $api.UI.Format.Decimal(model.PercJurosMensal) }}% a.m.
                    {{ $api.UI.Format.Decimal(model.PercJurosAnual) }}% a.a.
                  </span>
                </div>
                <div class="row-item">
                  Custo efetivo total (CET)
                  <span class="item-value">
                    {{ $api.UI.Format.Decimal(model.PercCETMensal) }} % a.m.
                    {{ $api.UI.Format.Decimal(model.PercCETAnual) }}% a.a.
                  </span>
                </div>
                <div class="row-item">
                  Data do Primeiro Vencimento
                  <span class="item-value"> {{ $api.UI.Format.Date(model.DtPrimeiroVencto) }} </span>
                </div>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="8" md="6">
            <v-row>
              <v-col cols="12" class="">
                <v-row class="text-subtitle-1">Parcelamento</v-row>
                <v-row class="text-caption mb-2">As parcelas serão descontadas na sua conta de FGTS</v-row>
                <v-row justify="space-between" class="pt-2" v-for="(item, index) in model.modelParcelas"
                  :key="index">
                  <span class="ml-3">{{ index + 1 }}ª Parcela - {{ $api.UI.Format.Date(item.DtRepasse) }}</span>
                  <span class="font-weight-bold pr-3 ">{{ $api.UI.Format.Currency(item.VlrRepasse) }}</span>
                </v-row>
                <div class="row-item destaque mt-2">
                  Valor Total das Parcelas
                  <v-icon @click="openAjuda" small color="primary" class="ml-1 mt-n1">ph-question</v-icon>
                  <span class="item-value">R$ {{ $api.UI.Format.Decimal(model.VlrParcelaCalculado) }}</span>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    value: {}
  },
  data () {
    return {
      ajuda: false,
      isLoaded: false,
    };
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        return this.$emit('input', value)
      }
    }
  },
  methods: {
    load (model) {
      this.$api.UTIL.Functions.SetAllButNull(this, this, 'model', model);
      this.isLoaded = true;
    },
    openAjuda () {
      this.ajuda = true
    }
  },
};
</script>

<style>
#resumo-proposta span.text-label {
  display: block;
  font-weight: 400;
}

#resumo-proposta span.text-h5 {
  font-weight: 400;
}

#resumo-proposta div.item-value {
  padding-bottom: 2px;
  padding-top: 2px;
  padding-left: 12px;
  padding-right: 12px;
  display: flex;
  justify-content: space-between;
}

#resumo-proposta span.text-value-label,
#resumo-proposta span.text-subtitle-1 {
  font-weight: 400;
}

#resumo-proposta span.text-value {
  text-align: end;
}
</style>
